var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 10.9905C10.0625 11.637 10.3193 12.257 10.7764 12.7141C11.2335 13.1712 11.8535 13.428 12.5 13.428C13.1465 13.428 13.7665 13.1712 14.2236 12.7141C14.6807 12.257 14.9375 11.637 14.9375 10.9905C14.9375 10.3441 14.6807 9.72409 14.2236 9.26697C13.7665 8.80985 13.1465 8.55304 12.5 8.55304C11.8535 8.55304 11.2335 8.80985 10.7764 9.26697C10.3193 9.72409 10.0625 10.3441 10.0625 10.9905Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0963 15.5866L13.6489 19.034C13.3442 19.3384 12.9311 19.5094 12.5004 19.5094C12.0697 19.5094 11.6566 19.3384 11.3519 19.034L7.90369 15.5866C6.99468 14.6776 6.37565 13.5194 6.12487 12.2585C5.8741 10.9976 6.00284 9.69072 6.49482 8.50302C6.9868 7.31532 7.81992 6.30018 8.88883 5.58596C9.95774 4.87175 11.2144 4.49054 12.5 4.49054C13.7856 4.49054 15.0423 4.87175 16.1112 5.58596C17.1801 6.30018 18.0132 7.31532 18.5052 8.50302C18.9972 9.69072 19.1259 10.9976 18.8751 12.2585C18.6243 13.5194 18.0053 14.6776 17.0963 15.5866Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIc);
export default __webpack_public_path__ + "static/media/loc_ic.bcdce0f911e1e75a9fe07f9397dbaac3.svg";
export { ForwardRef as ReactComponent };